import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import logo from '../../../../assets/images/vamos-horizontal-logo-darkbg.png';
import Icon from '../Icons/Icon';
import { logout } from '../../utils/api/logout';
import { redirectToUrl } from '../../utils/navigation';
import { getCurrentUserInfo } from '../../utils/api/registrations';
import UserRoleInfo from './UserRoleInfo';

const PageHeader = ({ organizationId = '', showToast }) => {
  const [iconName, setIconName] = useState('account');
  const [showOptions, setShowOptions] = useState(false);
  const buttonRef = useRef(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState({ value: '', label: '' });

  useEffect(() => {
    if (!organizationId) return;
    getCurrentUserInfo()
      .then((response) => response.json())
      .then((data) => {
        setCurrentUser(data.user);
        const org = data.user.organizations.find(organization => organization.id === organizationId);
        if (org && (org.id !== selectedOrg.value)) {
          setSelectedOrg({ value: org.id, label: org.name });
        }
      });
  }, [organizationId, selectedOrg.value]);

  const handleLogout = async () => {
    logout().then((resp) => {
      if (resp.ok) redirectToUrl('/');
    });
  };

  const handleBlur = (e) => {
    if (!buttonRef.current.contains(e.relatedTarget)) {
      setShowOptions(false);
      setIconName('account');
    }
  };

  return (
    <div className="fixed z-50 w-full h-16 bg-vamos-black flex items-center top-0 justify-between px-8.5">
      <a href="/">
        <img src={logo} alt="vamos logo" className="w-43.75 h-16" />
      </a>
      <div
        ref={buttonRef}
        tabIndex="-1"
        onBlur={handleBlur}
        className="flex relative"
      >
        {organizationId && (
          <>
            <div className="flex flex-row items-center text-xl font-medium space-x-2">
              <UserRoleInfo
                currentUser={currentUser}
                organizationId={organizationId}
                selectedOrg={selectedOrg}
                showToast={showToast}
              />
            </div>
            <button
              type="button"
              className={`group flex items-center justify-center ml-8.5 h-10 w-10 rounded-md focus:bg-vamos-white hover:bg-vamos-white ${showOptions ? 'bg-vamos-white' : 'text-vamos-white'}`}
              onMouseEnter={() => setIconName('account_black')}
              onMouseLeave={(e) => {
                if (!showOptions) {
                  e.currentTarget.blur();
                  setIconName('account');
                }
              }}
              onFocus={() => setIconName('account_black')}
              onClick={() => setShowOptions(!showOptions)}
              aria-label="Toggle user options menu"
              aria-expanded={showOptions}
            >
              <Icon name={iconName} />
            </button>
          </>
        )}
        {showOptions && (
          <div className="absolute right-0 top-12.5 w-28 flex flex-col bg-vamos-white rounded-md border border-vamos-light-gray text-sm py-1 z-50 borderWidth: 1">
            <a
              className="h-9.5 flex items-center px-3 hover:bg-vamos-v-light-gray focus:bg-vamos-v-light-gray focus:outline-none text-left"
              href="/admin/account"
            >
              Account
            </a>
            <button
              type="button"
              className="h-9.5 flex items-center px-3 hover:bg-vamos-v-light-gray focus:bg-vamos-v-light-gray focus:outline-none text-left"
              onClick={handleLogout}
            >
              Log out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;

PageHeader.propTypes = {
  organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showToast: PropTypes.func.isRequired,
};
